import "./global.scss";
import Routes from "./routes";

function App() {
  return (
    <div className="app-container">
      <Routes />
    </div>
  );
}

export default App;
